import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-google-maps-location',
  standalone: false,
  templateUrl: './google-maps-location.component.html',
  styleUrl: './google-maps-location.component.scss',
})
export class GoogleMapsLocationComponent {
  @Input() lat: number = 0;
  @Input() lng: number = 0;

  navigateToGoogleMaps() {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${this.lat},${this.lng}`;
    window.open(url, '_blank');
    // maybe no new tab, check on mobile later:
    // window.location.href = url;
  }
}
